import { dateObjectToYmd, isValidYmd } from '../../utils/flightDateUtils';

export const DEEPLINK_FLIGHT_PATH = '/deeplinks/flight';

export function isDeeplinkFlightPath(pathname) {
  return pathname === DEEPLINK_FLIGHT_PATH;
}

export function localTomorrowYmd(now = new Date()) {
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return dateObjectToYmd(tomorrow);
}

/** Use the query startDate, or tomorrow on /deeplinks/flight only. */
export function resolveFlightStartDate(pathname, startDateParam, now = new Date()) {
  const startDate = String(startDateParam || '').trim();
  if (isValidYmd(startDate)) return startDate;
  if (isDeeplinkFlightPath(pathname)) return localTomorrowYmd(now);
  return startDate;
}
